<template>
  <el-dialog v-model="visibleDialog" :visible.sync="visibleDialog" @close="visibleDialog=false" append-to-body>
    <div class="result-box">
      <img src="@/assets/images/border.png" class="border"/>
      <img src="@/assets/images/border2.png" class="border2"/>
      <div class="boxs">
        <div class="summary-title">查看全文</div>
        <div class="summary-ul">
          <div class="summary-li">
            <div class="result-text">
              <div class="text">{{ txt }}</div>
            </div>
            <!--              <div class="summary-bottom">
                            <div class="summary-left">
                              <audio src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3" controls autoplay loop muted></audio>
                            </div>
                            <div class="summary-right">
                              <div class="summary-bt"><img src="@/assets/images/m2.png"/>复制</div>
                            </div>
                          </div>-->
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    txt: {
      type: String,
      required: true,
    },
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.summary-bt:hover {
  border: 1px solid #525F89;
  color: #fff;
}

.summary-input {
  display: flex;
  border-radius: 8px;
  opacity: 0.8;
  height: 45px;
  padding: 0 12px;
  background: #0E1630;
  align-items: center;
  width: calc(100% - 48px);
  box-sizing: border-box;
  margin: auto;
  margin-bottom: 19px;

  /deep/ .el-input__inner {
    background: transparent;
    padding: 0;
    color: #fff;
    font-size: 16px;
  }

  img {
    width: 20px;
    margin-right: 12px;
  }
}

.summary-bt {
  display: flex;
  border: 1px solid transparent;
  align-items: center;
  border-radius: 4px;
  background: #393F52;
  color: rgba(255, 255, 255, 0.80);
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 100% */
  height: 24px;
  padding: 0 8px;
  cursor: pointer;
  justify-content: center;
  margin-left: 8px;

  img {
    width: 14px;
    margin-right: 2px;
  }
}

.summary-bottom {
  display: flex;
  margin-top: 12px;
  align-items: center;
  justify-content: space-between;

  .summary-left {
    audio {
      width: 189px;
      height: 36px;
    }
  }

  .summary-right {
    display: flex;
    align-items: center;
  }
}

.summary-title {
  line-height: 66px;
  color: #FFF;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 18px;
}

.border {
  width: 486px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.border2 {
  width: 486px;
  position: absolute;
  right: 0;
  top: 0;
}

.boxs {
  z-index: 999;
  position: relative;
}

.summary-ul {
  padding: 0 24px;
}

.result-text {
  border-radius: 8px;
  border: 1px solid #525F89;
  padding: 16px 12px;
  background: #393f52;
  text-align: left;
  box-sizing: border-box;

  .text {
    color: rgba(255, 255, 255, 0.80);
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    height: 685px;
    overflow: auto;
  }

  .text.active {
    max-height: initial !important;
  }

  .text-bt {
    color: #3CA0E9;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 100% */
    cursor: pointer;
    margin-top: 14px;
  }
}

.input-box {
  padding: 12px 20px 28px 20px;

  .input-bottom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 8px;

    img {
      width: 20px;
      cursor: pointer;
      margin-right: 16px;
      cursor: pointer;
    }

    .input-bt {
      border-radius: 4px;
      background: #AFC6F5;
      height: 26px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1656D7;
      font-size: 14px;
      cursor: pointer;

      img {
        margin-right: 4px;
        width: 12px;
      }
    }
  }

  .box-box {
    padding: 12px;
    margin-bottom: 12px;
  }

  /deep/ .el-input__count {
    background: transparent;
    top: -44px;
    left: 0px;
    right: initial;
  }

  /deep/ .el-textarea__inner {
    background: transparent !important;
    border: none;
    resize: none;
    height: 655px !important;
    font-size: 16px;
    line-height: 24px;
    padding: 0;
  }
}

/deep/ .el-dialog {
  margin: 0 !important;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  border-radius: 15px;
  border: 1px solid #1C2539;
  background: #262D40;
  width: 972px;
  height: 850px;
  position: absolute;

  .el-dialog__header {
    padding: 0;
    z-index: 9999;
    position: relative;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/summarize/fulltextModal.vue